import { render, staticRenderFns } from "./OrderFlowTypeButton.vue?vue&type=template&id=10d694ef&scoped=true&"
import script from "./OrderFlowTypeButton.vue?vue&type=script&lang=js&"
export * from "./OrderFlowTypeButton.vue?vue&type=script&lang=js&"
import style0 from "./OrderFlowTypeButton.vue?vue&type=style&index=0&id=10d694ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d694ef",
  null
  
)

export default component.exports